<template>
    <div class="container remove-padding-margin">
        <div class="fixed-judul fixed-top">
            <div class="row justify-content-center align-items-center set-row">
                <div class="col-md-3 col-sm-3 col-3 remove-padding" @click="back">
                    <img src="../../assets/gambar/back-blue.svg" alt="">
                </div>
                <div class="col-md-7 col-sm-7 col-7 text-center remove-padding">
                    <h6 class="remove-margin font-16 font-colorcheck text-promo">Ubah Layanan</h6>
                </div>
                <div class="col-md-2 col-sm-2 col-2 remove-padding"></div>
            </div>
        </div>
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1 pad-top-66">
                    <form action="">
                        <div class="form-group">
                            <label class="remove-margin require" for="namalayanan">Nama Layanan</label>
                            <input type="text" class="form-control inputs" id="namalayanan" aria-describedby="emailHelp"
                                   placeholder="Cuci Kering Setrika" v-model="nama_layanan" v-on:keyup="nameonly">
	                        <ErrorMessage class="error" label="Nama Layanan" :validation="$v.nama_layanan"></ErrorMessage>
	                        
                            <div class="form-row">
                                <div class="form-group col-md-6 col-sm-6 col-6">
                                    <label class="remove-margin mar-top-12 require" for="phone">Harga</label>
									<!--<div class="input-group remove-padding">-->
									<!--    <div class="input-group-prepend">-->
									<!--        <div class="input-group-text">Rp</div>-->
									<!--    </div>-->
									<!--    <input type="tel" class="form-control inputs" id="phone" value="0"-->
									<!--           v-model="harga_layanan" v-on:keyup="numberonly">-->
									<!--</div>-->
	                                <InputRupiah
		                                :outerDivClass="'input-group remove-padding'"
		                                v-model="harga_layanan"
		                                :showRp="true"
		                                :defaultValue="harga_layanan.formatted"
		                                :placeholder="14000"
		                                :comma="false"
	                                />
	                                <ErrorMessage class="error" label="Harga Layanan" :validation="$v.harga_layanan.raw"></ErrorMessage>
                                </div>
                                
	                            <div class="form-group col-md-6 col-sm-6 col-6">
                                    <label class="remove-margin mar-top-12 require" for="phone">Per</label>
                                    <select class="form-control" id="selectSatuan" v-model="selected">
                                        <option v-for="option in satuan_layanan"
                                                v-bind:value="{value:option.value, text: option.text}">
                                            {{ option.text }}
                                        </option>
                                    </select>
		                            <ErrorMessage class="error" label="Harga Layanan" :validation="$v.selected"></ErrorMessage>
                                </div>
                            </div>
                            
	                        <div><label class="remove-margin  require" for="phone">Durasi Pengerjaan</label></div>
                            <div class="row remove-padding-margin">
                                <div class="col-md-6 col-sm-6 col-6 remove-padding" style="padding-right: 4px">
	                                <InputMinPlus
		                                v-model="durasi_hari"
		                                :id="'hari'"
		                                :minValue="0"
		                                :maxValue="31"
		                                :metric="'Hari'"
		                                ref="inputminplus_hari"
	                                />
	                                <ErrorMessage class="error" label="Durasi Pengerjaan" :validation="$v.durasi_hari"></ErrorMessage>
                                </div>
                                <div class="col-md-6 col-sm-6 col-6 remove-padding text-right" style="padding-left: 4px">
	                                <InputMinPlus
		                                v-model="durasi_jam"
		                                :id="'jam'"
		                                :minValue="0"
		                                :maxValue="23"
		                                :metric="'Jam'"
		                                ref="inputminplus_jam"
	                                />
	                                <ErrorMessage class="error" label="Durasi Pengerjaan" :validation="$v.durasi_jam"></ErrorMessage>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="lebih-sedikit text-alignC" @click="showmore" id="nomore">
                        <h6 class="remove-padding-margin color-206CF">Pengaturan Lanjutan <span>
                            <img class="rotate" src="../../assets/icons/chevron-rotate-down.svg" alt="">
                        </span></h6>
                    </div>
                    <form action="">
                        <div class="form-group animated" id="more">
                            <label class="remove-margin mar-top-20">Kategori Layanan</label>
                            <select class="form-control tagging" id="suggestData" multiple="true"
                                    v-model="tagLayanan">
                                <option v-for="option in suggestarray"
                                        v-bind:value="option.value" >
                                    {{ option.text }}
                                </option>
                            </select>
                            <div class="custom-control custom-switch mar-top-20" style="padding: 0px 12px"
                                 id="togleorder" @click="orderedit">
                                <input type="checkbox" class="custom-control-input" id="togleorder2">
                                <label class="custom-control-label font-14 font-weight-bold" for="togleorder2">Aktifkan
                                    minimal order</label>
                            </div>
                            <div class="form-row" id="order" style="display: none">
                                <div class="form-group col-md-6 col-sm-6 col-6">
                                    <label class="remove-margin mar-top-12" for="reguler">Min. Order
                                        Reguler</label>
	                                <InputRupiah
		                                :outerDivClass="'input-group remove-padding'"
		                                v-model="order_reguler"
		                                @input="order_reguler"
		                                :showRp="true"
		                                :showRpPosition="'right'"
		                                :showRpText="selected === '' ? '.' : selected.text"
		                                :placeholder="10"
		                                ref="minregulerref"
	                                />
									<!--<div class="input-group remove-padding">-->
									<!--    <input type="tel" class="form-control inputs" id="reguler" placeholder="" value="0" v-model="order_reguler" v-on:keyup="inputreguler" v-on:keydown="inputreguler">-->
									<!--    <div class="input-group-prepend">-->
									<!--        <div class="input-group-text">{{selected.text}}</div>-->
									<!--    </div>-->
									<!--</div>-->
                                </div>
                                <div class="form-group col-md-6 col-sm-6 col-6">
                                    <label class="remove-margin mar-top-12" for="deposit">Min Order
                                        deposit</label>
	                                <InputRupiah
		                                :outerDivClass="'input-group remove-padding'"
		                                v-model="order_deposit"
		                                @input="order_deposit"
		                                :showRp="true"
		                                :showRpPosition="'right'"
		                                :showRpText="selected === '' ? '.' : selected.text"
		                                :placeholder="10"
		                                ref="mindepositref"
	                                />
									<!--<div class="input-group remove-padding">-->
									<!--    <input type="tel" class="form-control inputs" id="deposit" placeholder="" value="0" v-model="order_deposit" v-on:keyup="inputdeposit" v-on:keydown="inputdeposit">-->
									<!--    <div class="input-group-prepend">-->
									<!--        <div class="input-group-text">{{selected.text}}</div>-->
									<!--    </div>-->
									<!--</div>-->
                                </div>
                            </div>
                            <div class="custom-control custom-switch mar-top-20" style="padding: 0px 12px"
                                 @click="togleupahedit">
                                <input type="checkbox" class="custom-control-input" id="togleupah2">
                                <label class="custom-control-label font-14 font-weight-bold" for="togleupah2">Aktifkan
                                    upah borongan</label>
                            </div>
                            <div class="popup p-t-16" id="upah" style="display: none">
<!--                                <div class="form-row">-->
<!--                                    <div class="form-group col-md-6 col-sm-6 col-6" v-for="tahapanlayanan in inputtahapan" :key="tahapanlayanan.idtahapan">-->
<!--                                        <label class="remove-margin mar-top-12"-->
<!--                                               v-bind:for="tahapanlayanan.idtahapan">{{tahapanlayanan.text}}</label>-->
<!--                                        <div class="input-group remove-padding">-->
<!--											&lt;!&ndash;<input type="tel" class="form-control inputs upah" id="tahapan" placeholder="" v-bind:id="tahapanlayanan.idtahapan" v-bind:value="tahapanlayanan.value" v-on:keypress="max100(tahapanlayanan.idtahapan)">&ndash;&gt;-->
<!--	                                        <InputPersentase v-model="upahBorongan[tahapanlayanan.idtahapan]" :defaultValue="upahBorongan[tahapanlayanan.idtahapan].formatted"-->
<!--	                                                         :class="'form-control inputs'"/>-->
<!--	                                        <div class="input-group-prepend">-->
<!--                                                <div class="input-group-text">%</div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
	                            <UpahBoronganComponentV2
		                            :harga-layanan="harga_layanan.raw"
		                            :tahapan="tahapan"
		                            :upahBorongan="upahBorongan"
		                            @upah="(val) => { resultUpah = val }"
		                            ref="ubcref"
	                            />
                            </div>
                        </div>
                    </form>
                </div>
                <div class="button-lanjut">
                    <button type="button" class="btn btn-login btn-long" @click="editlayananV2" id="btnNext" :disabled="isClicked1" >
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="isClicked1 === true"></span><span id="textBtn2" v-if="!isClicked1">Simpan</span></button>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
	import InputMinPlus from "../../component-items/InputMinPlus";
	import InputPersentase from "@/component-items/InputPersentase";
	import InputRupiah from "@/component-items/InputRupiah";
	import UpahBoronganComponent from "@/components/Layanan/UpahBoronganComponent";
	import UpahBoronganComponentV2 from "@/components/Layanan/UpahBoronganComponentV2";
	import ErrorMessage from "@/component-items/ErrorMessage";
	import {minValue, minLength, required} from "vuelidate/lib/validators";

    export default {
        name: "EditLayanan",
        props:['setidoutletsetservice','setidoutlet','dataidlayanan'],
	    components: { InputMinPlus, InputPersentase, ErrorMessage, InputRupiah, UpahBoronganComponentV2 },
        data() {
            return {
                layanan: [],
                idlayanan: '',
                nama: '',
                nama_layanan: '',
                harga_layanan: {
                	raw: 0,
	                formatted: ""
                },
                satuan_layanan: [],
                tahapan: [],
                suggestarray: [],
                inputtahapan: [],
                isClicked: false,
                isClicked1: false,
                selected: '',
                durasi_hari: 0,
                durasi_jam: 0,
                kategori_layanan: '',
                order_reguler: {
                	formatted: "",
	                raw: 0,
                },
                order_deposit: {
                	formatted: "",
	                raw: 0,
                },
                status_toggle : 0,
                tagLayanan: [],
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
	            
	            upahBorongan: {},
	            resultUpah: {},
	            regexEmoji: {
		            name: /[^0-9A-Za-z_.,/'& -]+/g,
		            percent: /[^0-9.,]+/g,
	            }
            }
        },
	    validations: {
		    nama_layanan: {
			    required,
			    minLength: minLength(2),
		    },
		    harga_layanan: {
		    	raw: {
				    required,
				    minValue: minValue(1),
			    }
		    },
		    selected: {
			    required
		    },
		    durasi_hari: {
			    required
		    },
		    durasi_jam: {
			    required
		    }
	    },
        mounted() {
            this.idoutlet = this.$route.params.idoutlet
            this.idlayanan = this.$route.params.idlayanan
            this.getdetail()
            this.tagging()
            this.suggest()
            this.getsatuanMeta()
            $('.more').hide()
            $('#more').hide()
            this.cekValidate()
            $('#btnNext').prop('disabled', false);

	        $(document).on("keyup", ".select2-search__field", () => {
		        var val = $(".select2-search__field").val().replace(/[^a-zA-Z .,'-]+/g, "")
		        $(".select2-search__field").val(val)
	        })

            this.backButtonPressed(this.back);
        },
	    watch: {
		    nama_layanan: function () {
			    this.nama_layanan = this.nama_layanan.replace(this.regexEmoji.name,'')
		    },
	    },
        methods: {
            tagging() {
                $(".tagging").select2({
                    placeholder: "Ketuk Untuk Menambah Tag", //placeholder
                    tags: true,
	                createTag: function(params) {
		                var term = $.trim(params.term);
		                term = term.replace(/[^a-zA-Z .,'-]+/g, "")

		                return {
			                id: term,
			                text: term,
			                newTag: true // add additional parameters
		                }
	                },
                });
            },
            back() {
                this.$emit('gotolistlayanan')
            },
            rotate() {
                $('.rotate').toggleClass("down");
            },

            showmore() {
                $('#more').slideToggle(400)
                this.rotate()
            },

            countplus(dataId, type) {
                // var valueData = $('#' + dataId).val()
                // var valueInt = parseInt(valueData)
                // var math = valueInt + 1
                // $('#' + dataId).val(math)
                // $('#' + dataId + 'Text').val(math + ' ' + type)
                if (type === "Hari"){
                    var tempCount = this.durasi_hari + 1
                    if(tempCount <= 100){
                        this.durasi_hari++;
                    }
                } else {
                    var tempCount1 = this.durasi_jam + 1
                    if(tempCount1 <= 24){
                        this.durasi_jam++;
                    }
                }
                this.cekValidate()
            },
            countminus(dataId, type) {
                if (type === "Hari"){
                    var tempCount = this.durasi_hari - 1
                    if(tempCount >= 0){
                        this.durasi_hari--;
                    }
                } else {
                    var tempCount = this.durasi_jam - 1
                    if(tempCount >= 0){
                        this.durasi_jam--;
                    }
                }
                this.cekValidate()
            },

            orderedit(e) {
                // $('#customSwitch2').slideToggle(400)
                e.preventDefault()
                if (!$('#togleorder2').is(":checked")) {
                    $('#order').slideDown(400);
                    $('#togleorder2').prop('checked', true)
                } else {
                    $('#order').slideUp(400);
                    $('#togleorder2').prop('checked', false)
                }
            },
            togleupahedit(e) {
                e.preventDefault()
                if (!$('#togleupah2').is(":checked")) {
                    $('#upah').slideDown(400);
                    $('#togleupah2').prop('checked', true)
                } else {
                    $('#upah').slideUp(400);
                    $('#togleupah2').prop('checked', false)
                }
            },

            inputreguler(event){
                // let key = event.which || event.keyCode
                // if (key && (key <= 47 || key >= 58)) {
                //     event.preventDefault();
                // }
                var nums = event.target.value;
                var number = nums.replace(/[^0-9.]+/, '');
                this.order_reguler = number;
                this.formatrupiahorder(event)
            },
            formatrupiahorder(event){
            	var rupiah = event.target.value;
	            if (rupiah.includes(".")) {
		            var decimalCheck = rupiah.substr(rupiah.indexOf("."))
		            if (decimalCheck.length > 1) {
			            if (decimalCheck.substring(1).includes(".")) {
				            var decimalCheckReplace = decimalCheck.substring(1).replace(".", "")
				            this.order_reguler = rupiah.replace(decimalCheck, "." + decimalCheckReplace)
				            return;
			            }
		            } else {
			            return;
		            }
	            }
	            rupiah = parseFloat(rupiah).toString()
            	var formattedrupiah = this.newrupiahorder(rupiah);
            	this.order_reguler = formattedrupiah
            },
            newrupiahorder(angkareguler, prefixreguler){
              /* Fungsi formatRupiah */
              var number_string = angkareguler.replace(/[^.\d]/g, "").toString(),
                  split = number_string.split("."),
                  sisa = split[0].length % 3,
                  rupiah = split[0].substr(0, sisa),
                  ribuan = split[0].substr(sisa).match(/\d{3}/gi);
              // tambahkan titik jika yang di input sudah menjadi angka ribuan
              if (ribuan) {
                var separator = sisa ? "." : "";
                rupiah += separator + ribuan.join(".");
              }

              if (split[1] !== undefined) {
                if (split[1].length >= 2) {
                  if (parseFloat(split[1]) === 0) {
                    return 0
                  } else {
                    return rupiah + "." + split[1].substr(0, 2)
                  }
                }
              }
              rupiah = split[1] != undefined ? rupiah + "." + split[1] : rupiah;
              return prefixreguler == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            inputdeposit(event){
                // let key = event.which || event.keyCode
                // if (key && (key <= 47 || key >= 58)) {
                //     event.preventDefault();
                // }
                var nums = event.target.value;
                var number = nums.replace(/[^0-9.]+/, '');
                this.order_deposit = number;
                this.formatrupiahdeposit(event)
            },
            formatrupiahdeposit(event){
            	var rupiah = event.target.value;
	            if (rupiah.includes(".")) {
		            var decimalCheck = rupiah.substr(rupiah.indexOf("."))
		            if (decimalCheck.length > 1) {
			            if (decimalCheck.substring(1).includes(".")) {
				            var decimalCheckReplace = decimalCheck.substring(1).replace(".", "")
				            this.order_deposit = rupiah.replace(decimalCheck, "." + decimalCheckReplace)
				            return;
			            }
		            } else {
			            return;
		            }
	            }
            	var formattedrupiah = this.newrupiahdeposit(rupiah);
            	this.order_deposit = formattedrupiah
            },
            newrupiahdeposit(angkaupah, prefixupah){
              /* Fungsi formatRupiah */
              var number_string = angkaupah.replace(/[^.\d]/g, "").toString(),
                  split = number_string.split("."),
                  sisa = split[0].length % 3,
                  rupiah = split[0].substr(0, sisa),
                  ribuan = split[0].substr(sisa).match(/\d{3}/gi);
              // tambahkan titik jika yang di input sudah menjadi angka ribuan
              if (ribuan) {
                var separator = sisa ? "." : "";
                rupiah += separator + ribuan.join(".");
              }

              if (split[1] !== undefined) {
                if (split[1].length >= 2) {
                  if (parseFloat(split[1]) === 0) {
                    return 0
                  } else {
                    return rupiah + "." + split[1].substr(0, 2)
                  }
                }
              }

              rupiah = split[1] != undefined ? rupiah + "." + split[1] : rupiah;
              return prefixupah == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            max100(key){
                var inputkomisi = $('#' +key).val()
                // $('.upah').keyup(function(){
                if (inputkomisi> 100){
                    $('#' +key).val('100');
                }
                // });
                this.upahinput(key)
                this.decimal(key)
            },

            upahinput(key){
                var handleeventkomisi = $('#'+ key).val();
                var handlenumber = handleeventkomisi.replace(/[^0-9.]+/,'');
                $('#'+ key).val(handlenumber)
                // var nums = event.target.value;
                // var number = nums.replace(/[^0-9]+/, '');
                // event.target.value = number;
            },

            decimal(key){
                $('#' + key).keydown(function (e) {
                    //Get the occurence of decimal operator
                    var match = $(this).val().match(/\./g);
                    if(match!=null){
                        // Allow: backspace, delete, tab, escape and enter
                        if ($.inArray(e.keyCode, [46,8, 9, 27, 13, 110]) !== -1 ||
                            // Allow: Ctrl+A
                            (e.keyCode == 65 && e.ctrlKey === true) ||
                            // Allow: home, end, left, right
                            (e.keyCode >= 35 && e.keyCode <= 39)) {
                            // let it happen, don't do anything
                            return;
                        }  // Ensure that it is a number and stop the keypress
                        else if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105 )&&(e.keyCode==190)) {
                            e.preventDefault();
                        }
                    }
                    else{
                        // Allow: backspace, delete, tab, escape, enter and .
                        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
                            // Allow: Ctrl+A
                            (e.keyCode == 65 && e.ctrlKey === true) ||
                            // Allow: home, end, left, right
                            (e.keyCode >= 35 && e.keyCode <= 39)) {
                            // let it happen, don't do anything
                            return;
                        }
                        // Ensure that it is a number and stop the keypress
                        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                            e.preventDefault();
                        }
                    }
                });

                $('#' + key).keyup(function () {
                    if ($(this).val().indexOf('.') != -1) {
                        if ($(this).val().split(".")[1].length >= 2) {
                            if (isNaN(parseFloat(this.value))) return;
                            this.value=parseFloat(this.value).toFixed(2);
                        }
                    }
                })
            },

            nameonly(event) {
                var nums = event.target.value;
                var number = nums.replace(this.regexEmoji,'');;
                this.nama_layanan = number;
                this.cekValidate()
            },

            numberonly(event) {
                var nums = event.target.value;
                var number = nums.replace(/[^0-9]+/, '');
                this.harga_layanan = number;
                this.formatrupiah(event)
                this.cekValidate()
            },

            formatrupiah(event){
                var rupiah = event.target.value;
                var formattedrupiah = this.newrupiah(rupiah);
                this.harga_layanan = formattedrupiah
            },

            newrupiah(angka, prefix){
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^.\d]/g, "").toString(),
                    split = number_string.split("."),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            cekValidate() {
            	return
                let namasnap = this.nama_layanan;
                var hargasnap = this.harga_layanan;
                var DurasiHari = this.durasi_hari;
                var DurasiJam = this.durasi_jam;
                // var select = this.selected;
                var lenPass = namasnap.length;
                if (lenPass >= 2 && (hargasnap.length !== 0) && (DurasiHari >= 0 && DurasiJam >= 0)) {
                    $('#btnNext').prop('disabled', false);
                    if ((DurasiHari === 0 && DurasiJam === 0)) {
                        $('#btnNext').prop('disabled', true);
                    }
                } else {
                    $('#btnNext').prop('disabled', true);
                }
            },

            async getsatuanMeta() {
                this.isClicked = true
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const satuan = new FormData
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/satuan_meta', this.requestHeaders)
                    if (response.status === 200) {
                        var layanan = response.data.data;
                        this.satuan_layanan.push({value: "", text: "Pilih Satuan"})
                        for (var i = 0; i < layanan.length; i++) {
                        	// if (layanan[i].iddata_satuan !== 14) {
		                        this.satuan_layanan.push({
			                        value: layanan[i].iddata_satuan,
			                        text: layanan[i].nama
		                        })
	                        // }
                        }
                        this.isClicked = false
                        $('#loadingPage').removeClass('overlayLoading');
                    } else {
                        this.$toast.error(response.data.msg)
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked2 = false
	                $('#textBtnother').show()
	                $('#anotherButton').prop('disabled', false);
                }
            },

            async gettahapan() {
                this.isClicked = true;
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/tahapan_meta', this.requestHeaders)
                    if (response.status === 200) {
                        var rawtahapan = response.data.data
                        for (var i = 0; i < rawtahapan.length; i++) {
                            this.tahapan.push({idtahapan: rawtahapan[i].idtahapan, text: rawtahapan[i].nama})
                        }
                    }
                    this.isClicked = false;
                    $('#loadingPage').removeClass('overlayLoading');
                } catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked2 = false
	                $('#textBtnother').show()
	                $('#anotherButton').prop('disabled', false);
                }
            },

            async suggest() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_suggest_tags_layanan', this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            var suggest = response.data.data
                            for (var i = 0; i < suggest.length; i++) {
                                this.suggestarray.push({value: suggest[i].idtags, text: suggest[i].nama})
                            }
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked2 = false
	                $('#textBtnother').show()
	                $('#anotherButton').prop('disabled', false);
                }
            },
            async getdetail() {
                $('#loadingPage').show()
                $('#loadingPage').addClass('overlayLoading');
                if(!this.idlayanan){
                    this.idlayanan=this.parentidlayanan;
                }
                try {
	                await this.gettahapan()
                	
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_layanan?idlayanan=' + this.dataidlayanan.idlayanan + '&idoutlet=' + this.setidoutletsetservice, this.requestHeaders)
                    if (response.data.status === true) {
                        var layanan = response.data.data
                        var nominal = layanan.harga;
                        var toRp = this.newrupiah(nominal.toString());
                        // return
                        this.nama_layanan = layanan.layanan.nama_layanan;
                        this.harga_layanan.raw = nominal
                        this.harga_layanan.formatted = toRp;
                        this.selected = {
                            value: layanan.layanan.satuan.iddata_satuan,
                            text: layanan.layanan.satuan.nama
                        };
                        this.order_reguler.raw = layanan.min_order_reg;
                        this.order_deposit.raw = layanan.min_order_depo;
	                    this.$refs.minregulerref.getValRupiah(this.order_reguler.raw.toString().replace(".", ","))
	                    this.$refs.mindepositref.getValRupiah(this.order_deposit.raw.toString().replace(".", ","))
                        if(this.order_reguler.raw >0 || this.order_deposit.raw >0){
                            $('#order').slideDown(400);
                            $('#togleorder2').prop('checked', true)
                            $('#more').slideDown(400);
                            $('.rotate').toggleClass("down");
                        }
                        this.durasi_hari = this.convertMiliseconds(layanan.layanan.durasi_penyelesaian)
	                    this.durasi_jam = this.sisaJam(layanan.layanan.durasi_penyelesaian)
	                    this.$refs.inputminplus_hari.setValue(this.durasi_hari)
	                    this.$refs.inputminplus_jam.setValue(this.durasi_jam)
                        var inputtahapan = layanan.layanan.upah_tahapan_layanan
	
	                    for (var j = 0; j < this.tahapan.length; j++) {
		                    this.inputtahapan.push({
			                    idtahapan: this.tahapan[j].idtahapan,
			                    text: this.tahapan[j].text,
			                    value: 0
		                    })
		                    this.upahBorongan[this.tahapan[j].idtahapan] = {
			                    idtahapan: this.tahapan[j].idtahapan,
			                    text: this.tahapan[j].text,
			                    value: 0,
			                    raw: 0,
			                    formatted: "0",
		                    }
	                    }

	                    if (inputtahapan.length > 0) {
		                    var upahBorongan = 0;
		                    for (var i = 0; i < inputtahapan.length; i++) {
		                    	upahBorongan += inputtahapan[i].upah;
			                    var upahPercen = this.convertToPercent(inputtahapan[i].upah, layanan.harga)
			                    this.upahBorongan[inputtahapan[i].tahapan_idtahapan] = {
				                    idtahapan: inputtahapan[i].tahapan_idtahapan,
				                    text: inputtahapan[i].tags.nama,
				                    value: upahPercen,
				                    raw: upahPercen,
				                    formatted: upahPercen.toString().replace(".", ","),
			                    }
		                    }
		                    this.$refs.ubcref.setHargaLayanan(this.harga_layanan.raw)
		                    this.$refs.ubcref.setup(this.upahBorongan)

		                    if (upahBorongan > 0) {
			                    $('#upah').slideDown(400);
			                    $('#togleupah2').prop('checked', true);
			                    $('#more').slideDown(400);
			                    $('.rotate').toggleClass("down");
		                    }
	                    }
                        
                        var arrayTagsLayanan = layanan.layanan.layanan_tags
                        for (var x = 0; x < arrayTagsLayanan.length; x++) {
                            this.tagLayanan.push(layanan.layanan.layanan_tags[x].tags.idtags)
                        }
                        if(arrayTagsLayanan.length>0){
                            $('#more').slideDown(400);
                            $('.rotate').toggleClass("down");
                        }
                        $('#suggestData').val(this.tagLayanan).trigger('change');
                        $('#loadingPage').hide()
                        $('#loadingPage').removeClass('overlayLoading');
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },
	
	        errorValidation() {
		        this.$v.nama_layanan.$touch()
		        this.$v.harga_layanan.raw.$touch()
		        this.$v.selected.$touch()
		        this.$v.durasi_hari.$touch()
		        this.$v.durasi_jam.$touch()
		        return this.$v.nama_layanan.$invalid ||
			        this.$v.harga_layanan.raw.$invalid ||
			        this.$v.selected.$invalid ||
			        this.$v.durasi_hari.$invalid ||
			        this.$v.durasi_jam.$invalid
	        },
            async editlayanan() {
            	if (this.errorValidation()) {
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
            		return
	            }
            	if (parseInt(this.durasi_hari) === 0 && parseInt(this.durasi_jam) === 0) {
		            this.$toast.error("Durasi tidak boleh kosong")
            		return
	            }
                this.isClicked1 = true
                $('#textBtn2').hide()
                $('#btnNext').prop('disabled', true);
                var dataTags = $("#suggestData").select2('data')
                var hargalayanan = this.harga_layanan.formatted.toString()
                try {
                    const edit = new FormData()
                    edit.append('durasi_penyelesaian_hari', this.durasi_hari)
                    edit.append('durasi_penyelesaian_jam', this.durasi_jam)
                    for (var i = 0; i < dataTags.length; i++) {
                        edit.append('tags[]', dataTags[i].text)
                    }
                    var inputTahapan = this.tahapan
                    // for (var x = 0; x < inputTahapan.length; x++) {
                    //     edit.append(inputTahapan[x].idtahapan, $("#" + inputTahapan[x].idtahapan).val())
                    // }
	                if ($('#togleupah2').is(":checked")) {
		                for (var idtahapan in this.upahBorongan) {
			                edit.append(idtahapan, this.upahBorongan[idtahapan].formatted)
		                }
	                } else {
		                for (var idtahapan in this.upahBorongan) {
			                edit.append(idtahapan, "0")
		                }
	                }
                    edit.append('nama_layanan', this.nama_layanan)
                    edit.append('idsatuan', this.selected.value)
                    edit.append('harga', hargalayanan)
                    edit.append('jumlah', '1')
                    edit.append('idoutlet', this.setidoutletsetservice)
                    // edit.append('idowner',localStorage.getItem('idowner'))
                    if($('#togleorder2').is(':checked')) {
                      edit.append('min_order_reg', this.order_reguler.raw)
                      edit.append('min_order_depo', this.order_deposit.raw)
                    } else {
                      edit.append('min_order_reg', "0")
                      edit.append('min_order_depo', "0")
                    }
                    const response = await this.$axios.post(this.$baseurl + '/masterData/layanan/update_layanan?idlayanan=' + this.dataidlayanan.idlayanan, edit, this.requestHeaders);
                    if(response.data.status===true){
                        this.isClicked1 = false
                        $('#textBtn2').show()
                        $('#btnNext').prop('disabled', false);
                        this.$toast.success(response.data.msg)
                        this.back()
                    }else{
                        this.isClicked1 = false
                        $('#textBtn2').show()
                        $('#btnNext').prop('disabled', false);
                        this.$toast.error(response.data.msg)
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked1 = false
	                $('#textBtnother').show()
	                $('#anotherButton').prop('disabled', false);
                }
            },
	        async editlayananV2() {
		        if (this.errorValidation()) {
			        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
			        return
		        }
		        if (parseInt(this.durasi_hari) === 0 && parseInt(this.durasi_jam) === 0) {
			        this.$toast.error("Durasi tidak boleh kosong")
			        return
		        }
		        this.isClicked1 = true
		        $('#textBtn2').hide()
		        $('#btnNext').prop('disabled', true);
		        var dataTags = $("#suggestData").select2('data')
		        var hargalayanan = this.harga_layanan.formatted.toString()
		        try {
			        const edit = new FormData()
			        edit.append('durasi_penyelesaian_hari', this.durasi_hari)
			        edit.append('durasi_penyelesaian_jam', this.durasi_jam)
			        for (var i = 0; i < dataTags.length; i++) {
				        edit.append('tags[]', dataTags[i].text)
			        }
			        var inputTahapan = this.tahapan
			        // for (var x = 0; x < inputTahapan.length; x++) {
			        //     edit.append(inputTahapan[x].idtahapan, $("#" + inputTahapan[x].idtahapan).val())
			        // }
			        if ($('#togleupah2').is(":checked")) {
				        for (let i = 0; i < this.tahapan.length; i++) {
					        let id = this.tahapan[i].idtahapan
					        edit.append(this.resultUpah[id].rupiah.idtahapan, this.resultUpah[id].rupiah.raw)
				        }
			        } else {
				        for (var idtahapan in this.upahBorongan) {
					        edit.append(idtahapan, "0")
				        }
			        }
			        edit.append('nama_layanan', this.nama_layanan)
			        edit.append('idsatuan', this.selected.value)
			        edit.append('harga', hargalayanan)
			        edit.append('jumlah', '1')
			        edit.append('idoutlet', this.setidoutletsetservice)
			        // edit.append('idowner',localStorage.getItem('idowner'))
			        if($('#togleorder2').is(':checked')) {
				        edit.append('min_order_reg', this.order_reguler.raw)
				        edit.append('min_order_depo', this.order_deposit.raw)
			        } else {
				        edit.append('min_order_reg', "0")
				        edit.append('min_order_depo', "0")
			        }
			        const response = await this.$axios.post(this.$baseurl + '/masterData/layanan/update_layanan_v2?idlayanan=' + this.dataidlayanan.idlayanan, edit, this.requestHeaders);
			        if(response.data.status===true){
				        this.isClicked1 = false
				        $('#textBtn2').show()
				        $('#btnNext').prop('disabled', false);
				        this.$toast.success(response.data.msg)
				        this.back()
			        }else{
				        this.isClicked1 = false
				        $('#textBtn2').show()
				        $('#btnNext').prop('disabled', false);
				        this.$toast.error(response.data.msg)
			        }
		        } catch (e) {
			        this.$catch_error_response(e)
			        this.isClicked1 = false
			        $('#textBtnother').show()
			        $('#anotherButton').prop('disabled', false);
		        }
	        },
            convertMiliseconds(miliseconds) {
                var days, hours, minutes, seconds, total_hours, total_minutes, total_seconds;

                total_seconds = parseInt(Math.floor(miliseconds / 1000));
                total_minutes = parseInt(Math.floor(total_seconds / 60));
                total_hours = parseInt(Math.floor(total_minutes / 60));
                days = parseInt(Math.floor(total_hours / 24));

                seconds = parseInt(total_seconds % 60);
                minutes = parseInt(total_minutes % 60);
                hours = parseInt(total_hours % 24);

                return days
            },

            sisaJam(miliseconds) {
                var days, sisa_jam, sisa_menit, total_hours, total_minutes, total_seconds;

                total_seconds = parseFloat(Math.floor(miliseconds / 1000));
                total_minutes = parseFloat(Math.floor(total_seconds / 60));
                total_hours = parseFloat(Math.floor(total_minutes / 60));
                days = parseFloat(Math.floor(total_hours / 24));
                sisa_jam = parseFloat(Math.floor(total_hours % 24));
                sisa_menit = parseFloat(total_minutes % 60) / 60
                return sisa_jam + sisa_menit
            },

            convertToPercent(upah, harga_awal) {
                var getPercent = (upah / harga_awal) * 100
                return parseFloat(getPercent)
            }
        }
    }
</script>

<style scoped>
    .width-input {
        max-width: 50%;
    }

    .set-input {
        border: 1px solid #C8D0DD;
        margin: 0px 1px;
        text-align: center;
        padding: 5px;
        margin-left: 0px;
        margin-right: 0px;
    }

    .set-button {
        background: #FFFFFF;
        border: 1px solid #C8D0DD;
        box-sizing: border-box;
        border-radius: 0px 3px 3px 0px;
        width: 36px;
        padding: 5px;
        color: #206CFF;
    }
</style>